var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons8Tracking1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 3.20001C14.28 3.20001 6.39999 11.08 6.39999 20.8C6.39999 32.3744 17.8445 37.9167 19.2781 39.2063C20.7421 40.5231 21.9495 43.4733 22.4375 45.1469C22.6743 45.9597 23.3408 46.3699 24 46.3875C24.6608 46.3683 25.3257 45.9581 25.5625 45.1469C26.0505 43.4733 27.2579 40.5247 28.7219 39.2063C30.1555 37.9167 41.6 32.3744 41.6 20.8C41.6 11.08 33.72 3.20001 24 3.20001ZM17.6 12.8H30.4C31.2832 12.8 32 13.5168 32 14.4V27.2C32 28.0832 31.2832 28.8 30.4 28.8H17.6C16.7168 28.8 16 28.0832 16 27.2V14.4C16 13.5168 16.7168 12.8 17.6 12.8ZM20.8 16V17.6H27.2V16H20.8Z",
    fill: "#22428F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Tracking1);
export default __webpack_public_path__ + "static/media/icons8-tracking 1.099b31a4c4a329a7ff04f89958cb6202.svg";
export { ForwardRef as ReactComponent };